import { Button, Checkbox, Col, DatePicker, Input, Popconfirm, Row, Select, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import { testProfile } from "./cancelFunction.js";
const { TextArea } = Input;

function ActivePersonalAccounts(props) {
  const [profileModel, setProfileModel] = useState(testProfile);
  const [time, setTime] = useState(new Date());
  const [accounts, setAccounts] = useState('');
  const [clearSchedules, setClearSchedules] = useState(false);
  const [verifyAd, setVerifyAd] = useState(false);
  const [needActive, setNeedActive] = useState(false);
  const [needCancel, setNeedCancel] = useState(false);
  const [ignoreDie, setIgnoreDie] = useState(false);
  const [whopay, setWhopay] = useState(true);
  const [selectNoPayer, setSelectNoPayer] = useState(false);
  const [fillDuns, setFillDuns] = useState(false);
  const [verifyDUNS, setVerifyDUNS] = useState(false);
  const [cancelAfterVerify, setCancelAfterVerify] = useState(false);
  const [firstFileError, setFirstFileError] = useState(false);
  const [name, setName] = useState('MAI DUC TRANH');
  const [orgName, setOrgName] = useState('CAPIVARA LLC');
  const [address, setAddress] = useState('117 S Lexington St Ste 100');
  const [duns, setDuns] = useState('132172939');
  const [zip, setZip] = useState('64701-2444');
  const [city, setCity] = useState('Harrisonville');
  const [state, setState] = useState('Colorado');
  const [fileType, setFiletype] = useState('Passport');
  const [country, setCountry] = useState('United States');

  const [files, setFiles] = useState('Nguyễn Văn A/T.pdf/S.pdf/L.pdf');
  const [file, setFile] = useState('ADE LLC.pdf');

  const [quantity, setQuantity] = useState('5');

  const [messageApi, contextHolder] = message.useMessage();

  const active = async () => {
    let body = {
      jobName: `active_PERSONAL-${profileModel?.data?.name}`,
      time: time,
      data: {
        profileId: props.profile.id,
        accounts: accounts,
        needClearSchedules: clearSchedules,
        verifyAd,
        needActive,
        needCancel,
        ignoreDie,
        verifyDUNS,
        whopay,
        selectNoPayer,
        fillDuns,
        cancelAfterVerify,
        firstFileError,
        verifyInfo: {
          name: name,
          orgName: orgName,
          address: address, 
          duns: duns,
          city: city,
          state: state,
          zip: zip,
          file: file,
          type: fileType,
          country: country
        },
        files,
        quantity
      },
    };
    axios
      .post(`${API_HOST}/api/schedule/active`, body)
      .then((res) => messageApi.success("Đã đặt lệnh"))
      .catch((e) => {
        console.log("🚀 ~ active ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  const onOpenChange = (open) => {
    if (open) {
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };
  useEffect( () => {

    let needActive = localStorage.getItem('tkcn-verify-needActive');
    if(needActive) {
      setNeedActive(needActive === 'true');
    }
    let needCancel = localStorage.getItem('tkcn-verify-needCancel');
    if(needCancel) {
      setNeedCancel(needCancel === 'true');
    }
    let ignoreDie = localStorage.getItem('tkcn-verify-ignoreDie');
    if(ignoreDie) {
      setIgnoreDie(ignoreDie === 'true');
    }
    let verifyAd = localStorage.getItem('tkcn-verify-verifyAd');
    if(verifyAd) {
      setVerifyAd(verifyAd === 'true');
    }
    let clearSchedules = localStorage.getItem('tkcn-verify-clearSchedules');
    if(clearSchedules) {
      setClearSchedules(clearSchedules === 'true');
    }
    let cancelAfterVerify = localStorage.getItem('tkcn-verify-cancelAfterVerify');
    if(cancelAfterVerify) {
      setCancelAfterVerify(cancelAfterVerify === 'true');
    }
    let firstFileError = localStorage.getItem('tkcn-verify-firstFileError');
    if(firstFileError) {
      setFirstFileError(firstFileError === 'true');
    }
    let selectNoPayer = localStorage.getItem('tkcn-verify-selectNoPayer');
    if(selectNoPayer) {
      setSelectNoPayer(selectNoPayer === 'true');
    }

    const name = localStorage.getItem('verify-Name');
    if(name) {
      setName(name);
    }
    const orgName = localStorage.getItem('verify-orgName');
    if(orgName) {
      setOrgName(orgName);
    }
    const address = localStorage.getItem('verify-address');
    if(address) {
      setAddress(address);
    }
    const duns = localStorage.getItem('verify-duns');
    if(duns) {
      setDuns(duns);
    }
    const zip = localStorage.getItem('verify-zip');
    if(zip) {
      setZip(zip);
    }
    const city = localStorage.getItem('verify-city');
    if(city) {
      setCity(city);
    }
    const state = localStorage.getItem('verify-state');
    if(state) {
      setState(state);
    }
    const files = localStorage.getItem('verify-files');
    if(files) {
      setFiles(files);
    }
    const file = localStorage.getItem('verify-file');
    if(file) {
      setFile(file);
    }

    const fileType = localStorage.getItem('verify-fileType');
    if(fileType) {
      setFiletype(fileType);
    }
    const country = localStorage.getItem('verify-country');
    if(country) {
      setCountry(country);
    }
    let quantity = localStorage.getItem('verify-quantity');
    if(quantity) {
      setQuantity(quantity);
    } 

  }, [])

  const onOk = (value) => {
    if(value) {
      setTime(value.toDate());
    } else {
      setTime(new Date());
    }
  };

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ minWidth: 500 }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Kích hoạt TKCN"
        description={
          <>
              {profileModel?.errorMsg?.length> 0  &&
                <label style={{ color: "red", border: '1px solid red'}}>
                  <strong>{profileModel?.errorMsg}</strong></label>
              }
              <label>Chọn Giờ: </label>
              <br />
              <DatePicker showTime onOk={onOk} />
              <br />
              <br />

              <Row>
                <Col span={8}>
                  <Checkbox checked={verifyDUNS} onChange={e => {
                    setVerifyDUNS(e.target.checked)
                    window.localStorage.setItem("verify-duns-api", e.target.checked+'');
                  }}>
                    XM DUNS v 1.0
                  </Checkbox>
                  <br />
                  <Checkbox checked={fillDuns} onChange={e => setFillDuns(e.target.checked)}>
                    Điền Thông Tin DUNS
                  </Checkbox>
                  <br />
                  <Checkbox checked={whopay} onChange={e => setWhopay(e.target.checked)}>
                    Có Trả Lời "Who Pay..."
                  </Checkbox>
                  <br />
            
                </Col>
                <Col span={16}>
                  <b>Who pays for your ads?</b>
                  <br />
                  <Checkbox checked={!selectNoPayer} onChange={e => setSelectNoPayer(!e.target.checked)}>
                    "Yes, we pay Google Ads directly"
                  </Checkbox>
                  <br />
                  <Checkbox checked={selectNoPayer} onChange={e => setSelectNoPayer(e.target.checked)}>
                    "No, an agency pays and invoices us"
                  </Checkbox>
                </Col>
              </Row>

              {!verifyDUNS && 
                <>
                  <br />
                  <Checkbox checked={needActive} onChange={e => {
                    setNeedActive(e.target.checked);
                    localStorage.setItem("tkcn-verify-needActive", `${e.target.checked}`);
                  }}>
                    Kích hoạt TK
                  </Checkbox>
                  <br />
                  <Checkbox checked={needCancel} onChange={e => {
                    setNeedCancel(e.target.checked);
                    localStorage.setItem("tkcn-verify-needCancel", `${e.target.checked}`);
                  }}>
                    Hủy TK
                  </Checkbox>
                  <br />
                  <Checkbox checked={ignoreDie} onChange={e => {
                    setIgnoreDie(e.target.checked);
                    localStorage.setItem("tkcn-verify-ignoreDie", `${e.target.checked}`);
                  }}>
                    Kích hoạt cả TK Die
                  </Checkbox>
                  <br />
                  <Checkbox checked={verifyAd} onChange={e => {
                    setVerifyAd(e.target.checked);
                    localStorage.setItem("tkcn-verify-verifyAd", `${e.target.checked}`);
                  }}>
                    Xác Minh NQC
                  </Checkbox>
                  <br />
                  <Checkbox checked={clearSchedules} onChange={e => {
                    setClearSchedules(e.target.checked)
                    localStorage.setItem("tkcn-verify-clearSchedules", `${e.target.checked}`);
                  }}>
                    Hủy Lịch Ads
                  </Checkbox>
                  <br />
                  <Checkbox checked={firstFileError} onChange={e => {
                    setFirstFileError(e.target.checked);
                    localStorage.setItem("tkcn-verify-firstFileError", `${e.target.checked}`);
                  }}>
                    XM lần 1 Lỗi ~~ XM Lại
                  </Checkbox>
                  <br />
                  <Checkbox checked={cancelAfterVerify} onChange={e => {
                    setCancelAfterVerify(e.target.checked);
                    localStorage.setItem("tkcn-verify-cancelAfterVerify", `${e.target.checked}`);
                  }}>
                    Hủy Sau Khi XM
                  </Checkbox>
                  <br />
                  <Checkbox checked={selectNoPayer} onChange={e => {
                    setSelectNoPayer(e.target.checked);
                    localStorage.setItem("tkcn-verify-selectNoPayer", `${e.target.checked}`);
                  }}>
                    Chọn: "No, an agency pays and invoices us"
                  </Checkbox>
                  <br />
                </>
              }
          
              <Row>
                <Col span={2}>
                  <label>SL Max: </label>
                </Col>
                <Col span={22}>
                  <Input
                    value={quantity}
                    style={{ width: '200px' }}
                    placeholder="Số Lượng ..."
                    onChange={(e) => {
                      setQuantity(e.target.value);
                      localStorage.setItem('verify-quantity', e.target.value);
                    }}
                  />
                </Col>
                <Col span={12}>
                {/* <label><strong>Thông Tin NQC: </strong></label> */}
                <br />
                <form id="active-form">
                  <Row>
                    <Col span={12}>
                      <label>Chọn Loại File: </label>
                      <Select
                          style={{width: '200px'}}
                          value={fileType}
                          placeholder="Chọn Loại File ... "
                          onChange={(v) => {
                            setFiletype(v);
                            window.localStorage.setItem("verify-fileType", v);
                          }}
                          options={[
                            {
                              label: 'Passport',
                              value: 'Passport',
                            },
                            {
                              label: 'CCCD',
                              value: 'National Identity Card',
                            },
                            {
                              label: 'Driver License',
                              value: 'Driver License',
                            },
                            {
                              label: 'State ID',
                              value: 'State ID',
                            },
                            {
                              label: 'Green Card',
                              value: 'Green Card',
                            },
                          ]}
                        />
                    </Col>
                    <Col span={12}>
                      <label>Chọn Quốc Gia: </label>
                      <Select
                          style={{width: '200px'}}
                          value={country}
                          placeholder="Chọn Quốc Gia ... "
                          onChange={(v) => {
                            setCountry(v);
                            window.localStorage.setItem("verify-country", v);
                          }}
                          options={[
                            {
                              label: 'VN',
                              value: 'Vietnam',
                            },
                            {
                              label: 'US',
                              value: 'United States',
                            },

                          ]}
                        />
                    </Col>
                  </Row>
                  <button type="submit" style={{display:'none'}}></button>
                </form>
                </Col>

              </Row>
              <br />
              <label>
                <strong>Tên Người + Ảnh Upload: Theo Mẫu <i style={{color:'red'}}>(Mỗi Người 1 dòng)</i></strong>
                <br/>
                <div>...</div>
                <div>Tên-1 / Ảnh Trước / Ảnh Sau / Ảnh Lỗi</div>
                <div>Tên-2 / Ảnh Trước / Ảnh Sau / Ảnh Lỗi</div>
                <div>...</div>
                {/* <br />VD: <i style={{color:'red'}}>1.jpg,2.pdf/4T.pdf-4S.pdf/7.pdf</i> = <u>Ảnh 1</u> [1.jpg hoặc 2.pdf] + <u>Ảnh 2</u> [4T.pdf Trước và 4S.pdf Sau] + <u>Ảnh Lỗi</u> [7.pdf] */}
              </label>
              <TextArea 
                style={{width: 800}}
                rows={10}
                value={files}
                placeholder='Nguyễn Văn A/T.pdf/S.pdf/L.pdf'
                onChange={(e) => {
                      setFiles(e.target.value );
                      window.localStorage.setItem("verify-files", e.target.value);
                }} />
              <br />

          </>
        }
        onConfirm={() => active()}
      >
        <Button style={{backgroundColor:'green', color:'white'}}><b>Kích Hoạt & XM TKCN</b></Button>
      </Popconfirm>
    </>
  );
}
export default ActivePersonalAccounts;